import { render, staticRenderFns } from "./ServicesSelector.vue?vue&type=template&id=5850d96c&"
import script from "./ServicesSelector.vue?vue&type=script&lang=js&"
export * from "./ServicesSelector.vue?vue&type=script&lang=js&"
import style0 from "./ServicesSelector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports